export default "__VITE_ASSET__Cu_Bxs6X__"